import React from 'react';
import './AboutUs.css';
import logo from './apnaghar.png'; 
import { Helmet } from 'react-helmet-async';

function AboutUs() {
  return (
    <>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>About ApkaGhr | Trusted PG & Rental Platform in Assam</title>
        <meta
          name="description"
          content="Learn about ApkaGhr, a platform dedicated to helping people in Assam find PGs, rental houses, and properties with ease with 100% broker and commission free."
        />
        <meta name="keywords" content="About ApkaGhr, PG in Assam, Rent House Assam, Assam Rentals, Verified Listings" />
        <meta name="author" content="ApkaGhr Team" />

        {/* Open Graph / Social Sharing */}
        <meta property="og:title" content="About ApkaGhr | Trusted PG & Rental Platform in Assam" />
        <meta property="og:description" content="Learn about ApkaGhr, a platform dedicated to helping people in Assam find PGs, rental houses, and properties with ease." />
        <meta property="og:image" content={logo} />
        <meta property="og:url" content="https://www.apkaghr.com/homepage/about-us" />
        <link rel="canonical" href="https://www.apkaghr.com/homepage/about-us" />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About ApkaGhr | Trusted PG & Rental Platform in Assam" />
        <meta name="twitter:description" content="Learn about ApkaGhr, a platform dedicated to helping people in Assam find PGs, rental houses, and properties with ease." />
        <meta name="twitter:image" content={logo} />
      </Helmet>

      {/* Page Content */}
      <div className="about-wrapper">
        <div className="about-card">
          <img src={logo} alt="ApnaGhar Logo" className="about-logo" />
          <h1 className="about-heading">About Us</h1>

          <div className="about-section">
            <h2>🏠 About Apkaghr</h2>
            <p>
              <strong>Apkaghr</strong> is a simple and reliable platform designed to help 
              people in Assam and nearby regions find <strong>PGs, rental houses, and 
              properties</strong> with ease. Our goal is to make house-hunting and listing 
              transparent, quick, and stress-free.
            </p>
          </div>

          <div className="about-section">
            <h2>🌿 Our Roots in Assam</h2>
            <p>
              At Apkaghr, we are <strong>solely focused on serving the people of Assam</strong>. 
              Assam is not just our market, it is our <em>home</em>. Every listing and service feels 
              <strong>local, authentic, and trustworthy</strong>.
            </p>
          </div>

          <div className="about-section">
            <h2>⚖️ Legal Disclaimer</h2>
            <p>
              Please note, <strong>Apkaghr is not a registered company</strong> at this time. 
              We operate as a community-driven initiative connecting property owners with tenants.
            </p>
          </div>

          <div className="about-section">
            <h2>🤝 Community Support</h2>
            <p>
              We invite the people of Assam to join us in building a transparent and reliable platform.
            </p>
          </div>

          <div className="about-section">
            <h2>👥 Our Team</h2>
            <p>
              Founded by <strong>Ankur Bhuyan</strong> and <strong>Nikhil Bordoloi</strong>, Apkaghr aims to make property finding easier and community-oriented.
            </p>
          </div>

          <div className="about-section">
            <h2>📧 Contact Us</h2>
            <p>
              Have questions or need support? <br />
              <a href="mailto:support@apkaghr.com" className="about-email">
                support@apkaghr.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default AboutUs;
